// Components==============
import { faClock, faMapMarkerAlt } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AnimatePresence, motion } from 'framer-motion';
import React from 'react';
import { useSelector } from 'react-redux';
import { interactiveScale } from 'utilities/framerAnimations';
import { getActivityBackground } from 'utilities/getActivityBackground';
import { months } from 'utilities/months';
import { useOpenUrlModal } from 'utilities/useOpenUrlModal';
import './ActivityCard.module.scss';
import ActivityModal from '../ActivityModal/ActivityModal';
// =========================

export default function ActivityCard({ activity, setActiveActivity }) {
    const background = getActivityBackground(activity);

    const school = useSelector(
        (state) => state.school.entities.byId?.[activity?.school_id]
    );

    const openModal = useOpenUrlModal(`activity-popup/${activity?.id}`);

    const labels = [
        {
            icon: faClock,
            value: activity.time,
        },
        {
            icon: faMapMarkerAlt,
            value: activity.location,
        },
    ];

    const month = months[activity.convertedDate.getMonth()];

    return (
        <>
            <motion.div
                styleName="card"
                {...interactiveScale}
                onClick={() => {
                    setActiveActivity(activity.id);
                    openModal();
                }}
            >
                <div styleName="left" style={{ background: `${background}cc` }}>
                    <h1>{activity.convertedDate.getDate()} </h1>
                    <p>{month.substring(0, 3)}</p>
                </div>
                <div styleName="right">
                    <p styleName="title">{activity.name}</p>
                    <div styleName="content">
                        {labels.map(
                            (label) =>
                                !!label?.value && (
                                    <div key={label.value} styleName=" label">
                                        <FontAwesomeIcon icon={label.icon} />
                                        <p styleName="label-text">
                                            {label.value}
                                        </p>
                                    </div>
                                )
                        )}
                    </div>
                </div>
            </motion.div>

            <AnimatePresence>
                <ActivityModal activity={activity} />
            </AnimatePresence>
        </>
    );
}
